/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { CHALLENGE_CLIP_SOURCES, COLLECTION_CLIP_CANDIDATE_SOURCES } from '@repo/config';
import { z } from 'zod';

export { CHALLENGE_CLIP_SOURCES, COLLECTION_CLIP_CANDIDATE_SOURCES };
export const collectionClipCandidateSourceSchema = z.enum(COLLECTION_CLIP_CANDIDATE_SOURCES);
export type ICollectionClipCandidateSource = z.infer<typeof collectionClipCandidateSourceSchema>;

export const challengeClipSourceSchema = z.enum(CHALLENGE_CLIP_SOURCES);
export type IChallengeClipSource = z.infer<typeof challengeClipSourceSchema>;

export const CHALLENGE_CLIP_SOURCE_LABELS: Record<IChallengeClipSource, string> = {
  match: 'Match',
  extract: 'AI',
  manual: 'Manual',
  requested: 'Requested',
  grammar: 'Grammar',
  quote: 'Quote',
};
